import { Tab } from '@mui/material'
import React from 'react'

export default function SidebarItem({ name, active, handleClick, icon }) {
  return (
    <Tab sx={{borderRadius:'10px'}} label={name} icon={icon} iconPosition="start" onClick={handleClick} className={active ? 'active' : null}/>
  )
}